import React from 'react';

const Card = () => {
    return (
        <div className='bg-cyan-500 h-32 mt-4   flex justify-between items-center px-14'>
            <h1 className='py-4 text-white font-bold font-mono ml-3 text-2xl'>6  EVENTS
            </h1 >
            <h1 className='py-4 text-white font-bold font-mono ml-3 text-2xl'>30+ EXPECTED TEAMS
            </h1>
            <h1 className='py-4 text-white font-bold font-mono ml-3 text-2xl'>120 +
                EXPECTED PARTICIPANTS
            </h1>
        </div>
    );
};

export default Card;